import { datadogRum } from "@datadog/browser-rum";
import { nextjsPlugin } from "@datadog/browser-rum-nextjs";

import {
  getDefaultAllowedTracingUrls,
  rumErrorEventMatchesMonitoringWhitelist,
} from "@stadium/services/error-reporting/monitoring-urls";
import { scrubMonitoringPayload } from "@stadium/services/error-reporting/scrub";

import { getDatadogRumConfig, isDatadogRumEnabled } from "../rum-config";

/**
 * @param {Object} options
 * @param {string[]|RegExp[]} [options.allowedTracingUrls]
 * @param {string[]|RegExp[]} [options.whitelistedUrls]
 */
export const generateDatadogInitialisationConfig = ({
  allowedTracingUrls = getDefaultAllowedTracingUrls(),
  whitelistedUrls = [],
  sessionSampleRate,
  sessionReplaySampleRate,
} = {}) => {
  const rumConfig = getDatadogRumConfig({ sessionSampleRate, sessionReplaySampleRate });

  return {
    ...rumConfig,
    trackUserInteractions: true,
    allowedTracingUrls,
    plugins: [nextjsPlugin()],
    beforeSend: (event) => {
      if (
        event.type === "error" &&
        whitelistedUrls?.length &&
        !rumErrorEventMatchesMonitoringWhitelist(event, whitelistedUrls)
      ) {
        return false;
      }
      return scrubMonitoringPayload(event);
    },
  };
};

const isRumInitialized = () => {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return Boolean(datadogRum.getInitConfiguration?.());
  } catch {
    return Boolean(window.DD_RUM?.version);
  }
};

export const initialiseClient = (config = generateDatadogInitialisationConfig()) => {
  if (typeof window === "undefined") {
    return null;
  }

  if (isRumInitialized()) {
    return datadogRum;
  }

  if (!isDatadogRumEnabled() || !config.applicationId || !config.clientToken) {
    return null;
  }

  datadogRum.init(config);
  return datadogRum;
};
